export default {
    order: null,
    currentStep: 0,
    blocks: [],
    hasUpdate: false,
    currentStepIsValid: true,
    editMode: true
}
